module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_asakusa-0fde757dd4badf2c83661eb2b1532ea6.jpg";